<template>
  <div class="page-college">
    <ic-banner v-if="columnMeta" :data="columnMeta"></ic-banner>
    <div class="g-wrap card-wrap">
      <college-card
        :data="item"
        :key="i"
        v-for="(item, i) in columnData"
      ></college-card>
    </div>
  </div>
</template>

<script>
import News from "_c/News";
import Banner from "_c/Banner";
import Card from "./CollegeCard";
import { getData } from "api/app";
export default {
  data() {
    return {
      columnData: [],
      columnMeta: {
        name: "特色产业学院",
        enName: "Characteristic industry college",
        pic: "/static/img/banner-college.png"
      }
    };
  },
  created() {
    this.init();
  },
  components: {
    [News.name]: News,
    [Banner.name]: Banner,
    [Card.name]: Card
  },
  methods: {
    loadData() {
      getData({ name: "College" }).then(res => {
        this.columnData = res || [];
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-college {
  .card-wrap {
    display: flex;
    flex-wrap: wrap;
    padding-top: 32px;
  }
  ::v-deep .comp-college-card {
    margin: 0 24px 32px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
